import { render, staticRenderFns } from "./whoisInformationModal.vue?vue&type=template&id=f6d39592&scoped=true"
import script from "./whoisInformationModal.vue?vue&type=script&lang=js"
export * from "./whoisInformationModal.vue?vue&type=script&lang=js"
import style0 from "./whoisInformationModal.vue?vue&type=style&index=0&id=f6d39592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d39592",
  null
  
)

export default component.exports